var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTickList = function SvgTickList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tick_list_svg2__a",
    x1: -44.7,
    x2: 110.3,
    y1: 120.2,
    y2: -25.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#tick_list_svg2__a",
    id: "tick_list_svg2__b",
    x1: -45.9,
    x2: 109.1,
    y1: 119,
    y2: -27
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#tick_list_svg2__a",
    id: "tick_list_svg2__c",
    x1: -11.6,
    x2: 143.4,
    y1: 155.4,
    y2: 9.4
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#tick_list_svg2__a",
    id: "tick_list_svg2__d",
    x1: -7.5,
    x2: 147.5,
    y1: 159.8,
    y2: 13.8
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#tick_list_svg2__a",
    id: "tick_list_svg2__e",
    x1: -8.7,
    x2: 146.3,
    y1: 158.4,
    y2: 12.4
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#tick_list_svg2__a",
    id: "tick_list_svg2__f",
    x1: -9.9,
    x2: 145.1,
    y1: 157.2,
    y2: 11.2
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#tick_list_svg2__a",
    id: "tick_list_svg2__g",
    x1: 24.4,
    x2: 179.4,
    y1: 193.6,
    y2: 47.6
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#tick_list_svg2__a",
    id: "tick_list_svg2__h",
    x1: 28.5,
    x2: 183.5,
    y1: 198,
    y2: 52
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#tick_list_svg2__a",
    id: "tick_list_svg2__i",
    x1: 27.3,
    x2: 182.3,
    y1: 196.6,
    y2: 50.6
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#tick_list_svg2__a",
    id: "tick_list_svg2__j",
    x1: 26.1,
    x2: 181.1,
    y1: 195.4,
    y2: 49.4
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#tick_list_svg2__a",
    id: "tick_list_svg2__k",
    x1: 60.4,
    x2: 215.4,
    y1: 231.8,
    y2: 85.8
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#tick_list_svg2__a",
    id: "tick_list_svg2__l",
    x1: 64.5,
    x2: 219.5,
    y1: 236.2,
    y2: 90.2
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M53.3 0C37.9 0 25.4 12.5 25.4 27.9s12.5 27.9 27.9 27.9 27.9-12.5 27.9-27.9S68.7 0 53.3 0m0 49.5c-11.9 0-21.7-9.7-21.7-21.6S41.3 6.2 53.3 6.2 75 15.9 75 27.9s-9.7 21.6-21.7 21.6",
    style: {
      strokeWidth: 0,
      fill: "url(#tick_list_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59.7 19.8-9.6 9.6-3.1-3.1c-1.2-1.2-3.2-1.2-4.4 0s-1.2 3.2 0 4.4l5.3 5.3c.6.6 1.4.9 2.2.9s1.6-.3 2.2-.9l11.8-11.8c1.2-1.2 1.2-3.2 0-4.4s-3.2-1.2-4.4 0",
    style: {
      strokeWidth: 0,
      fill: "url(#tick_list_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.7 20.8h73.8c1.7 0 3.1-1.4 3.1-3.1s-1.4-3.1-3.1-3.1H97.7c-1.7 0-3.1 1.4-3.1 3.1s1.4 3.1 3.1 3.1",
    style: {
      strokeWidth: 0,
      fill: "url(#tick_list_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.7 41.2h48c1.7 0 3.1-1.4 3.1-3.1s-1.4-3.1-3.1-3.1h-48c-1.7 0-3.1 1.4-3.1 3.1s1.4 3.1 3.1 3.1",
    style: {
      strokeWidth: 0,
      fill: "url(#tick_list_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3 72.1c-15.4 0-27.9 12.5-27.9 27.9s12.5 27.9 27.9 27.9 27.9-12.5 27.9-27.9-12.5-27.9-27.9-27.9m0 49.6c-11.9 0-21.7-9.7-21.7-21.6s9.7-21.7 21.7-21.7S75 88.1 75 100.1s-9.7 21.6-21.7 21.6",
    style: {
      strokeWidth: 0,
      fill: "url(#tick_list_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59.7 91.9-9.6 9.6-3.1-3.1c-1.2-1.2-3.2-1.2-4.4 0s-1.2 3.2 0 4.4l5.3 5.3c.6.6 1.4.9 2.2.9s1.6-.3 2.2-.9l11.8-11.8c1.2-1.2 1.2-3.2 0-4.4s-3.2-1.2-4.4 0",
    style: {
      strokeWidth: 0,
      fill: "url(#tick_list_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.5 86.7H97.7c-1.7 0-3.1 1.4-3.1 3.1s1.4 3.1 3.1 3.1h73.8c1.7 0 3.1-1.4 3.1-3.1s-1.4-3.1-3.1-3.1",
    style: {
      strokeWidth: 0,
      fill: "url(#tick_list_svg2__g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.7 113.3h48c1.7 0 3.1-1.4 3.1-3.1s-1.4-3.1-3.1-3.1h-48c-1.7 0-3.1 1.4-3.1 3.1s1.4 3.1 3.1 3.1",
    style: {
      strokeWidth: 0,
      fill: "url(#tick_list_svg2__h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3 144.2c-15.4 0-27.9 12.5-27.9 27.9S37.9 200 53.3 200s27.9-12.5 27.9-27.9-12.5-27.9-27.9-27.9m0 49.5c-11.9 0-21.7-9.7-21.7-21.6s9.7-21.7 21.7-21.7S75 160.1 75 172.1s-9.7 21.6-21.7 21.6",
    style: {
      strokeWidth: 0,
      fill: "url(#tick_list_svg2__i)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59.7 164-9.6 9.6-3.1-3.1c-1.2-1.2-3.2-1.2-4.4 0s-1.2 3.2 0 4.4l5.3 5.3c.6.6 1.4.9 2.2.9s1.6-.3 2.2-.9l11.8-11.8c1.2-1.2 1.2-3.2 0-4.4s-3.2-1.2-4.4 0",
    style: {
      strokeWidth: 0,
      fill: "url(#tick_list_svg2__j)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.5 158.8H97.7c-1.7 0-3.1 1.4-3.1 3.1s1.4 3.1 3.1 3.1h73.8c1.7 0 3.1-1.4 3.1-3.1s-1.4-3.1-3.1-3.1",
    style: {
      strokeWidth: 0,
      fill: "url(#tick_list_svg2__k)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.7 179.2h-48c-1.7 0-3.1 1.4-3.1 3.1s1.4 3.1 3.1 3.1h48c1.7 0 3.1-1.4 3.1-3.1s-1.4-3.1-3.1-3.1",
    style: {
      fill: "url(#tick_list_svg2__l)",
      strokeWidth: 0
    }
  }));
};
export default SvgTickList;